import React from 'react';
import {
    FormControl,
    FormLabel,
    FormHelperText,
} from '@material-ui/core';
import get from 'lodash.get';
import {Controller, useFormContext} from 'react-hook-form';
import {FancyTable} from 'components';


const TableInput = ({label, children, ...props}) => {
    return (
        <FancyTable
            title={label}
            {...props}
        >
            {children}
        </FancyTable>
    );
};

const TableInputField = ({
    headers,
    label,
    name,
    required,
    onChange,
    input,
    children,
}) => {
    const {control, errors} = useFormContext();
    const error = get(errors, name);

    return (
        <FormControl error={!!error} style={{width: '100%'}}>
            <FormLabel id={`${name}-label`} required={required}>
                {label}
            </FormLabel>
            <Controller
                render={p => (
                    <TableInput
                        headers={headers}
                        label={label}
                        name={p.name}
                        error={!!error}
                        onBlur={p.onBlur}
                        onChange={data => {
                            onChange(data);
                            p.onChange(data);
                        }}
                        value={p.value}
                    >
                        {input}
                    </TableInput>
                )}
                name={name}
                control={control}
            />
            <FormHelperText>{error?.message}</FormHelperText>
        </FormControl>
    );
};

export default TableInputField;
